import React from 'react';
import Check from '@mui/icons-material/Check';
import { StepIconProps } from '@mui/material/StepIcon';
import styles from './CustomStepIcon.module.scss';

const CustomStepIcon: React.FC<StepIconProps> = ({ active, completed, className }) => {
  return (
    <div className={`${styles.root} ${active ? styles.active : ''} ${completed ? styles.completed : ''}`}>
      {completed ? <div className={styles.circle} /> : <div className={styles.circle} />}
    </div>
  );
};

export default CustomStepIcon;
